export default "__VITE_ASSET__DugJ4HJW__"